import { CLAIMS_ACTION_TYPE } from 'store/global/actions';

const initialState = [];

const claimsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case CLAIMS_ACTION_TYPE.GET_CLAIMS:
      return payload || state;

    default:
      return state;
  }
};

export default claimsReducer;
